/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TimePatchEntryPayload = {
    properties: {
        minute: {
            type: 'any-of',
            contains: [{
                type: 'MinuteMove',
            }, {
                type: 'null',
            }],
        },
        startTime: {
            type: 'any-of',
            contains: [{
                type: 'StartTimeMove',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
